import { gql } from '@apollo/client';

export const DELETE_CONTENT_TYPE = gql`
  mutation deleteContentType($id: Int!) {
    deleteContentType(id: $id) {
      commandId
      correlationId
    }
  }
`;
